import { falsy } from '../utils/falsy';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class DropdownMenu {
	constructor(elem, options) {
		this.elem = elem;
		this.dropdown = null;
		this.isOpen = false;

		this.options = {
			selectors: {},
			classes: {},
			...options,
		};

		this.setTarget();
		this.addEvents();
	}

	setTarget() {
		this.dropdown = document.querySelector(this.options.selectors.dropdown);
		this.rootElem = document.querySelector(this.options.selectors.root);
		this.closingElems = document.querySelectorAll(this.options.selectors.closing);
		this.menuText = document.querySelector('.header__actions-text');
	}

	addEvents() {
		if (!falsy(this.elem)) {
			this.elem.addEventListener('click', (e) => {
				this.makeVisible();
				e.preventDefault();
				this.toggleDropdown();

				setTimeout(() => {
					this.elem.blur();
				}, 300);
			});
		}

		document.addEventListener(
			'keydown',
			(e) => {
				if (this.isEscKey(e.key, e.keyCode) && e.target.nodeName === 'BODY' && this.isOpen) {
					this.close();
				}
			},
			true
		);

		if (this.closingElems.length > 0) {
			this.closingElems.forEach((elem) => {
				elem.addEventListener('click', (e) => {
					e.preventDefault();
					if (this.isOpen) {
						this.close();

						setTimeout(() => {
							this.elem.blur();
						}, 300);
					}
				});
			});
		}
	}

	makeVisible() {
		this.dropdown.classList.add('is-visible');
	}

	isEscKey(key, keyCode) {
		if (key === 'Escape' || key === 'Esc' || keyCode === 27) {
			return true;
		}
		return false;
	}

	toggleDropdown() {
		if (!this.isOpen) {
			this.open();
		} else {
			this.close();
		}
	}

	open() {
		if (this.dropdown !== null) {
			this.isOpen = true;
			[this.elem, this.dropdown].forEach((elem) => {
				if (!falsy(elem)) {
					elem.classList.add(this.options.classes.default);
				}
			});
			this.toggleRootElement();
			this.menuText.innerHTML = 'close';
			disableBodyScroll();
		}
		document.dispatchEvent(new CustomEvent('dropdownOpen', { detail: {} }));
	}

	close() {
		if (this.dropdown !== null) {
			this.isOpen = false;
			[this.elem, this.dropdown].forEach((elem) => {
				if (!falsy(elem)) {
					elem.classList.remove(this.options.classes.default);
				}
			});
			this.toggleRootElement();
			this.menuText.innerHTML = 'menu';
			enableBodyScroll();
		}
		document.dispatchEvent(new CustomEvent('dropdownClose', { detail: {} }));
	}

	toggleRootElement() {
		if (this.rootElem !== null) {
			if (this.isOpen) {
				this.rootElem.classList.add(this.options.classes.root);
			} else {
				this.rootElem.classList.remove(this.options.classes.root);
			}
		}
	}
}
